<div class="mat-elevation-z8">
  <div class="filter-actions-line">
    <mat-form-field appearance="outline">
      <mat-label>Select Disposal Site</mat-label>
      <mat-select [formControl]="selectedSiteIdControl">
        @for (stream of ldcSites(); track stream.id) {
          <mat-option [value]="stream.id">{{ stream.siteName }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width:250px">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker">
        <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
        <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <button id="ldcSearchButton" data-testid="ldcSearchButton" mat-raised-button color="primary"
      (click)="onSearch()">
      <mat-icon>search</mat-icon>Search
    </button>
    <!-- Add Button -->
    @if(controlPermissions.addButton){
      <button mat-raised-button color="primary" (click)="onAddOrEdit(null, 'Add')">
        <mat-icon>add</mat-icon>
        Add
      </button>
    }
  </div>
</div>
<div class="mat-elevation-z8 mar-top-20">
  <mat-card>
    <mat-card-content>
      <div class="gridheight clear-both viewport">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows matSort>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let row">
        <div>
          <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="onAddOrEdit(row, 'Edit')">
            <mat-icon>edit</mat-icon>
          </button>
          @if(controlPermissions.delete){
            <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDelete(row.id)" style="color: red;">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </td>
    </ng-container>

    <!-- Data Columns -->
    <ng-container matColumnDef="siteName">
      <th mat-header-cell *matHeaderCellDef>Site</th>
      <td mat-cell *matCellDef="let element"> {{element.siteName}} </td>
    </ng-container>
    <ng-container matColumnDef="tankName">
      <th mat-header-cell *matHeaderCellDef>Tank</th>
      <td mat-cell *matCellDef="let element"> {{element.tankName}} </td>
    </ng-container>
    <ng-container matColumnDef="dateCaptured">
      <th mat-header-cell *matHeaderCellDef>Sample Date</th>
      <td mat-cell *matCellDef="let element"> {{element.dateCaptured | date:'MM/dd/yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="reportDate">
      <th mat-header-cell *matHeaderCellDef>Report Date</th>
      <td mat-cell *matCellDef="let element"> {{element.reportDate | date:'MM/dd/yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="labDataName">
      <th mat-header-cell *matHeaderCellDef>Lab </th>
      <td mat-cell *matCellDef="let element"> {{element.labDataName }} </td>
    </ng-container>
    <ng-container matColumnDef="labReportId">
      <th mat-header-cell *matHeaderCellDef>Lab Data<br/>Report Id</th>
      <td mat-cell *matCellDef="let element"> {{element.labReportId}} </td>
    </ng-container>
    <ng-container matColumnDef="cod">
      <th mat-header-cell *matHeaderCellDef>COD (chemical oxygen demand) (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.cod}} </td>
    </ng-container>
    <ng-container matColumnDef="total_solids">
      <th mat-header-cell *matHeaderCellDef>Total Solids (%)</th>
      <td mat-cell *matCellDef="let element"> {{element.total_solids}} </td>
    </ng-container>
    <ng-container matColumnDef="volatile_solids">
      <th mat-header-cell *matHeaderCellDef>Total Volatile Solids (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.volatile_solids}} </td>
    </ng-container>
    <ng-container matColumnDef="ammonia">
      <th mat-header-cell *matHeaderCellDef>Total Ammonia (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.ammonia}} </td>
    </ng-container>
    <ng-container matColumnDef="sulfate">
      <th mat-header-cell *matHeaderCellDef>Sulfate (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.sulfate}} </td>
    </ng-container>
    <ng-container matColumnDef="pH">
      <th mat-header-cell *matHeaderCellDef>pH</th>
      <td mat-cell *matCellDef="let element"> {{element.pH}} </td>
    </ng-container>
    <ng-container matColumnDef="tic">
      <th mat-header-cell *matHeaderCellDef>TIC</th>
      <td mat-cell *matCellDef="let element"> {{element.tic}} </td>
    </ng-container>
    <ng-container matColumnDef="vfa">
      <th mat-header-cell *matHeaderCellDef>VFA</th>
      <td mat-cell *matCellDef="let element"> {{element.vfa}} </td>
    </ng-container>
    <ng-container matColumnDef="vfaByTIC">
      <th mat-header-cell *matHeaderCellDef>VFA by TIC</th>
      <td mat-cell *matCellDef="let element"> {{element.vfaByTIC}} </td>
    </ng-container>
    <ng-container matColumnDef="vfA_Acetic">
      <th mat-header-cell *matHeaderCellDef>VFA Acetic (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.vfA_Acetic}} </td>
    </ng-container>
    <ng-container matColumnDef="vfA_ropionic">
      <th mat-header-cell *matHeaderCellDef>VFA Propionic (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.vfA_ropionic}} </td>
    </ng-container>
    <ng-container matColumnDef="vfA_Butyric">
      <th mat-header-cell *matHeaderCellDef>VFA Butyric (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.vfA_Butyric}} </td>
    </ng-container>
    <ng-container matColumnDef="vfA_Valeric">
      <th mat-header-cell *matHeaderCellDef>VFA Valeric (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.vfA_Valeric}} </td>
    </ng-container>
    <ng-container matColumnDef="tkn">
      <th mat-header-cell *matHeaderCellDef>TKN<br />(Total Kjeldahl Nitrogen)<br />(mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.tkn}} </td>
    </ng-container>
    <ng-container matColumnDef="dissolved_sulfur">
      <th mat-header-cell *matHeaderCellDef>Total Sulfur (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.dissolved_sulfur}} </td>
    </ng-container>
    <ng-container matColumnDef="chlorides">
      <th mat-header-cell *matHeaderCellDef> Chlorides (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.chlorides}} </td>
    </ng-container>
    <ng-container matColumnDef="totalOrganicCarbon">
      <th mat-header-cell *matHeaderCellDef>Total Organic<br />Carbon (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.totalOrganicCarbon}} </td>
    </ng-container>
    <ng-container matColumnDef="phosphorus">
      <th mat-header-cell *matHeaderCellDef>Phosphorus (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.phosphorus}} </td>
    </ng-container>
    <ng-container matColumnDef="potassium">
      <th mat-header-cell *matHeaderCellDef>Potassium (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.potassium}} </td>
    </ng-container>
    <ng-container matColumnDef="oilandGrease">
      <th mat-header-cell *matHeaderCellDef>Oil and Grease<br /> (HEM) (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.oilandGrease}} </td>
    </ng-container>
    <ng-container matColumnDef="iron">
      <th mat-header-cell *matHeaderCellDef>Iron (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.iron}} </td>
    </ng-container>
    <ng-container matColumnDef="vfaIsovaleric">
      <th mat-header-cell *matHeaderCellDef>VFA - Isovaleric (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.vfaIsovaleric}} </td>
    </ng-container>
    <ng-container matColumnDef="vfaSuccinic">
      <th mat-header-cell *matHeaderCellDef> VFA - Succinic (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.vfaSuccinic}} </td>
    </ng-container>
    <ng-container matColumnDef="vfaCaproic">
      <th mat-header-cell *matHeaderCellDef>VFA - Caproic (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.vfaCaproic}} </td>
    </ng-container>
    <ng-container matColumnDef="vfaLactic">
      <th mat-header-cell *matHeaderCellDef>VFA - Lactic (mg/L)</th>
      <td mat-cell *matCellDef="let element"> {{element.vfaLactic}} </td>
    </ng-container>
    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef>Entered By</th>
      <td mat-cell *matCellDef="let element"> {{element.createdBy}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- No Data Row -->
    <tr class="mat-row hover:bg-transparent" *matNoDataRow>
      <td class="mat-cell text-center text-gray-500 py-4" [attr.colspan]="displayedColumns.length"
          style="color: red;text-align: center;font-weight: 500;">
        No data found for this site.
      </td>
    </tr>
  </table>
     </div>
    </mat-card-content>
  </mat-card>
</div>

